import * as components from './components';

export default [
    {
        path: '/technical-documentation',
        component: components.DocumentationList,
        name: 'documentationList'
    }
];


// WEBPACK FOOTER //
// ./ClientApp/app/technicaldocumentation/routes.js